import { Editor, Element, Node, Range, Transforms } from 'slate';

export const isFootnote = (n: Node): boolean => Element.isElement(n) && (n as any).type === 'footnote';

export function insertFootnote(editor: Editor, footnoteId: string): void {
  if (!editor.selection || Range.isCollapsed(editor.selection)) return;
  Transforms.wrapNodes(editor, { type: 'footnote', footnoteId, children: [] } as any, { split: true, at: editor.selection });
}

export function removeFootnote(editor: Editor, footnoteId: string): void {
  Transforms.unwrapNodes(editor, { at: [], match: (n) => isFootnote(n) && (n as any).footnoteId === footnoteId });
}

export function footnoteSnippet(editor: Editor, footnoteId: string): string | null {
  const entry = Array.from(Editor.nodes(editor, { at: [], match: (n) => isFootnote(n) && (n as any).footnoteId === footnoteId }))[0];
  return entry ? Node.string(entry[0]) : null;
}
